import MutualUserResult from '../result/MutualUserResult';
import MutualDAO from '../dao/MutualDAO';
import LogoutResult from '../result/LogoutResult';
import Config from '../model/config';


class MutualService {

	// This is to get the user instance based on the cookie 
	static async getUserInstance(): Promise<MutualUserResult> {
		return await MutualDAO.getUserInstance();
	}

	// This is to logout the user
	static async userLogout(): Promise<LogoutResult> {
		return await MutualDAO.userLogout();
	}

	static async getActiveSubscription(id : string): Promise<any> {
		return await MutualDAO.getActiveSubscription(id);
	}

	static async getConfigs(): Promise<Config> {
		return MutualDAO.getConfigs();
	}
}

export default MutualService;
